<script lang="ts" setup>
import EntryForm from '@/components/organisms/forms/entry/EntryForm.vue'
import TotalArea from '@/components/organisms/totalarea/TotalArea.vue'
import { useMiniVariantTariffState } from '@/views/variants/mini/mini-variant-tariff-state.composable'
import LnxCircleIcon from '@/components/icons/circle/LnxCircleIcon.vue'
import { useFeatureFlagStore } from '@/stores/feature-flag.store.ts'
import { storeToRefs } from 'pinia'
import { useUiStore } from '@/stores/ui.store.ts'
import { useGlobalErrorService } from '@/services/error.service.ts'
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth.store.ts'
import LinexoScoping from '@/components/linexo-scoping/LinexoScoping.vue'
import { useMiniVariantViewState } from '@/views/variants/mini/mini-view-state.composable'
import { useConnectStore } from '@/libs/api/connect/connect.store'
import { useRedirectButtonSetup } from '@/components/atom/redirect/redirect-button-setup.composable'

const errorService = useGlobalErrorService()

const uiStore = useUiStore()
const featureFlagStore = useFeatureFlagStore()
const authStore = useAuthStore()
const connectStore = useConnectStore()

const { flags } = storeToRefs(featureFlagStore)

const state = useMiniVariantTariffState()
const { validationResult, canRedirect, currentOfferDto, tariffState } = state

const siteconnectViewState = useMiniVariantViewState(state, errorService, uiStore, authStore)

useRedirectButtonSetup()

const mainContainerClasses = computed(() => {
  const styleName = 'main-container'
  if (flags.value.get('design-v1')) {
    return `${styleName} ${styleName}--grid-styles`
  }
  return styleName
})
</script>

<template>
  <LinexoScoping class="linexo-site-connect-mini">
    <main :class="mainContainerClasses" class="linexo-site-connect-mini lnx-container">
      <LnxCircleIcon v-if="flags.get('design-v1')" :is-loading="uiStore.isLoading" />
      <EntryForm
        ref="entryForm"
        variant="mini"
        v-model:form-data="tariffState"
        v-model:validation-result="validationResult"
        :product-offer="currentOfferDto"
        @update:form-data="siteconnectViewState.handleFormDataUpdateMini"
        @update:validation-result="siteconnectViewState.handleValidationResult"
        @on-update="siteconnectViewState.handleOnFormUpdate"
      />
      <TotalArea
        :is-loading="uiStore.isLoading"
        :is-valid="!!canRedirect"
        :price="state.currentPrice.value"
        :product-offer="currentOfferDto"
        :target-url="state.redirectUrl.value"
        :target-behavior="connectStore.getLinexoSettings!.redirectBehavior"
      />
    </main>
  </LinexoScoping>
</template>

<style lang="scss" scoped>
@import 'mini-view';
</style>
